import React from 'react';
import { Route } from 'react-router-dom';

import Inicio from '../Components/Inicio';

export default [
	<Route key="inicio" exact path="/" component={ Inicio } />,
	//<Route key="inicio-empresa" exact path="/:empresaName/inicio" component={ Inicio } />,
];
